export enum UserRoleEnum {
    Unknown = 0,
    Barista = 1,
    //BaristaAssistant = 2,
    ChiefInspector = 3,
    CommonEmployee = 4,
    //Cook = 5,
    DutyOperator = 6,
    ExternalEvidenceCollector = 7,
    Franchisee = 8,
    Inspector = 9,
    //ManagerAssistant = 10,
    OfficeWorker = 11,
    PortalAdministrator = 12,
    Probationer = 13,
    //Producer = 14,
    ShiftSupervisor = 15,
    Steward = 16,
    TerritorialDirector = 17,
    TradePointManager = 18,
    TradePointTablet = 19,
    Marketer = 20,
    Technologist = 21,
    OperatingDirector = 22,
    UkLeader = 23,
    Academy = 24,
    FabricWorker = 25,
    EmployeeFabricWorker = 26,
}
